export default __webpack_public_path__ + "images/41ae6e80e2bf5162abdb44b09e3a62a3.webp";